import { nanoid } from "@reduxjs/toolkit";

export interface IImageDimensionsData {
  id: string;
  url: string;
  width: number;
  height: number;
  resolution: number;
}

export const fetchImagesDimensions = async (
  url: string,
  id: string = nanoid(),
) => {
  return new Promise<IImageDimensionsData>((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      resolve({
        id,
        url,
        width: img.width,
        height: img.height,
        resolution: img.width * img.height,
      });
    };
    img.onerror = () => reject({ id, url });
  });
};
